import { createSlice } from '@reduxjs/toolkit';
import * as routineTimelineActionTypes from './routineTimelineActions.types';
import type { RoutineTimelineState } from './types/RoutineTimeline.types';

export const initialState: RoutineTimelineState = {
  status: 'idle',
  taskId: null,
  routine: null,
  routes: {},
  reports: [],
  unavailableRouteIndexes: [],
  stoppedStep: null,
  error: null,
};

const routineTimelineSlice = createSlice({
  name: 'routine-timeline',
  initialState,
  reducers: {
    openRoutineTimelineRequest: (
      _state,
      _action: routineTimelineActionTypes.OpenRoutineTimelineRequestAction
    ): RoutineTimelineState => ({ ...initialState, status: 'loading' }),
    openRoutineTimelineSuccess: (
      _state,
      action: routineTimelineActionTypes.OpenRoutineTimelineSuccessAction
    ): RoutineTimelineState => ({ ...initialState, ...action.payload, status: 'ready' }),
    // The current task is not a routine run, so there is no timeline.
    routineTimelineUnavailable: (): RoutineTimelineState => ({ ...initialState, status: 'unavailable' }),
    openRoutineTimelineError: (
      _state,
      action: routineTimelineActionTypes.OpenRoutineTimelineErrorAction
    ): RoutineTimelineState => ({ ...initialState, status: 'error', error: action.payload.error }),
    closeRoutineTimeline: (): RoutineTimelineState => initialState,
    refreshRoutineReportsRequest: (_state, _action: routineTimelineActionTypes.RefreshRoutineReportsRequestAction) =>
      undefined,
    routineReportsReceived: (state, action: routineTimelineActionTypes.RoutineReportsReceivedAction) => {
      if (state.status === 'ready') {
        state.reports = action.payload;
        // A report that arrives late is shown after all.
        state.unavailableRouteIndexes = state.unavailableRouteIndexes.filter(
          routeIndex => !action.payload.some(report => report.routeIndex === routeIndex)
        );
      }

      return state;
    },
    routineStoppedStepChanged: (state, action: routineTimelineActionTypes.RoutineStoppedStepChangedAction) => {
      state.stoppedStep = action.payload;
      return state;
    },
    routeReportsUnavailable: (state, action: routineTimelineActionTypes.RouteReportsUnavailableAction) => {
      if (state.status === 'ready') {
        state.unavailableRouteIndexes = Array.from(new Set([...state.unavailableRouteIndexes, ...action.payload]));
      }

      return state;
    },
  },
});

export const RoutineTimelineActions = {
  ...routineTimelineSlice.actions,
};
export const routineTimelineReducer = routineTimelineSlice.reducer;
